export const MODULES = [
  { key: "dashboard", label: "Dashboard", to: "/" },
  { key: "performance", label: "Plan vs Actual", to: "/performance" },
  { key: "dispatch", label: "Dispatch Report", to: "/dispatch" },
  { key: "manpower", label: "Manpower & OT", to: "/manpower" },
  { key: "sales", label: "Sales Master", to: "/sales" },
  { key: "meeting", label: "Daily Meeting", to: "/meeting" },
  { key: "trc", label: "TRC · Repair", to: "/trc" },
  { key: "quality", label: "Quality · IQC/OQC/PDI", to: "/quality" },
  { key: "qms", label: "QMS · ISO 9001", to: "/qms" },
  { key: "npi", label: "NPI Projects", to: "/npi" },
  { key: "ecn", label: "ECN Tracker", to: "/ecn" },
  { key: "sop", label: "SOP Documents", to: "/sop" },
  { key: "customer_loss", label: "Loss due to Customer", to: "/customer-loss" },
  { key: "customer_care", label: "Complaints & Audits", to: "/customer-care" },
  { key: "spares", label: "Spares & Consumables", to: "/spares" },
  { key: "prod_loss", label: "Production Loss (DA/DP)", to: "/production-loss" },
  { key: "scm", label: "SCM · BOM / PO / GRN / Inventory", to: "/scm" },
  { key: "fives", label: "Plant 5S", to: "/5s" },
  { key: "kaizen", label: "Kaizen", to: "/kaizen" },
  { key: "compliance", label: "Data Upload Status", to: "/compliance" },
  { key: "pipeline", label: "New Business Pipeline", to: "/pipeline" },
  { key: "costing", label: "Costing & Quotation", to: "/costing" },
  { key: "program", label: "Program Management", to: "/program" },
  { key: "pnl", label: "Monthly P&L", to: "/pnl" },
  { key: "margins", label: "SKU Margins (CM1 / CM2)", to: "/margins" },
  { key: "cashflow", label: "Cash Flow Master", to: "/cashflow" },
  { key: "master", label: "Master Data", to: "/master" },
];

const ALL = MODULES.map((m) => m.key);
export const ROLE_DEFAULT_MODULES = {
  master_admin: ALL,
  admin: ALL,
  mis: ALL.filter((k) => k !== "master"),
  management: ALL.filter((k) => !["production", "master"].includes(k)),
};

export const ROLE_LABEL = { master_admin: "Master Admin", admin: "Admin", mis: "MIS Executive", management: "Management", super_admin: "Platform Vendor" };

// Legacy module keys (entry / sheet) map to the merged production module
const legacy = (k) => (k === "entry" || k === "sheet" ? "production" : k);

// Effective modules: master admin always sees everything; others = explicit scope (if set) ∩ role defaults
export function allowedModules(user, enabled) {
  if (!user) return [];
  const gate = (list) => (Array.isArray(enabled) ? list.filter((k) => enabled.includes(k)) : list);
  if (user.role === "master_admin") return gate(ALL);
  const p = user.permissions || {};
  if (Object.keys(p).length) return gate(ALL.filter((k) => ["view", "edit"].includes(p[k])));
  const base = ROLE_DEFAULT_MODULES[user.role] || [];
  const scope = (user.modules || []).map(legacy);
  return gate(scope.length ? base.filter((k) => scope.includes(k)) : base);
}
export const canAccess = (user, key, enabled) => allowedModules(user, enabled).includes(key);
export const isEntryRole = (user) => ["master_admin", "admin", "mis"].includes(user?.role);
export const isAdminRole = (user) => ["master_admin", "admin"].includes(user?.role);

// Per-module View / Edit: user.permissions {module: "view"|"edit"} overrides role defaults
const MGMT_EDIT_DEFAULT = ["kaizen", "fives", "dashboard"];
export function modulePermission(user, key) {
  if (!user) return "none";
  if (user.role === "master_admin") return "edit";
  const p = user.permissions || {};
  if (Object.keys(p).length) return ["view", "edit"].includes(p[key]) ? p[key] : "none";
  if (user.modules?.length && !user.modules.map(legacy).includes(key)) return "none";
  if (user.role === "management") return MGMT_EDIT_DEFAULT.includes(key) ? "edit" : "view";
  return ["admin", "mis"].includes(user.role) ? "edit" : "none";
}
export const canEditModule = (user, key) => modulePermission(user, key) === "edit";
export const PERM_LEVELS = [["none", "None"], ["view", "View"], ["edit", "Edit"]];
